import React, { useEffect, useRef } from "react";
import { localize } from "redux-i18n";

import { withFocusFirstInput, View, Button } from "@components";

import "./style.scss";

type Props = {
  width?: string,
  className?: string,
  rightPanel?: boolean,
  title?: string,
  onToggle?: Function,
  children: React$Node,
  isSubmitBtnDisabled?: boolean,
  onSubmit?: Function,
  ...PropsFromLocalize,
};
function Modal(props: Props) {
  const {
    width,
    className,
    rightPanel,
    onToggle,
    children,
    title,
    onSubmit,
    isSubmitBtnDisabled,
    t,
  } = props;

  const isRightPanel = rightPanel;

  const backdropRef = useRef(null);

  useEffect(() => {
    document.addEventListener("keyup", onEscapeBtnClose);
    return () => {
      document.removeEventListener("keyup", onEscapeBtnClose);
    };
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--side-panel-width", width || "50vw");
  }, [width]);

  function onWrapperClick(e) {
    e.stopPropagation();
  }
  function onBackdropClick(e) {
    toggleModalWithPhisicalClick();
  }

  function toggleModalWithPhisicalClick() {
    const modalCloseButton = backdropRef.current.querySelector(".modal-close-button");
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  }

  function onEscapeBtnClose(e: KeyboardEvent) {
    if (e.keyCode === 27 && e.type == "keyup") {
      if (isRightPanel && onToggle) {
        onToggle();
      } else {
        toggleModalWithPhisicalClick();
      }
    }
  }

  return (
    <div
      ref={backdropRef}
      onClick={onBackdropClick}
      className={`modal-backdrop ${isRightPanel ? "right-panel" : ""}`}
    >
      <div onClick={onWrapperClick} className={`modal-wrapper ${className || "modal-large"} `}>
        {title && (
          <View flex={1} padding={[0, 6, 6, 6]} gap={3}>
            <View
              direction="row"
              separator="bottom"
              padding={[3, 0, 3, 0]}
              backgroundColor={"white"}
              position="sticky"
              zIndex={5}
              top={0}
              justifyContent="space-between"
            >
              <View flex={1}>
                <h3>{title}</h3>
              </View>
              <View gap={3} direction="row">
                <Button onClick={onToggle} color="secondary" label={t("CANCEL")} />

                <Button
                  onClick={onSubmit}
                  disabled={isSubmitBtnDisabled}
                  color="primary"
                  materialIcon="replay_circle_filled"
                  label={t("SUBMIT")}
                />
              </View>
            </View>
            {children}
          </View>
        )}
        {!title && children}
      </div>
    </div>
  );
}
export default localize()(Modal);

export const ModalHeader = (props: Object) => (
  <View
    {...props}
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    className={`modal-header  ${props.className || ""}`}
  >
    <h4>{props.children}</h4>
    <Button
      className="modal-close-button"
      onClick={props.toggle}
      color="secondary"
      materialIcon="close"
    />
  </View>
);
export function ModalBody(props) {
  const modalBodyRef = useRef(null);
  useEffect(() => {
    const input = modalBodyRef.current.querySelector(
      "input:not([type=hidden]):not([type=checkbox]):not([type=file]):not([readonly]):not([disabled]), textarea:not([readonly]):not([disabled])",
    );
    if (input && input.focus) {
      input.focus();
    }
  }, []);

  return (
    <div ref={modalBodyRef} {...props} className={`modal-body ${props.className || ""}`}>
      {props.children}
    </div>
  );
}

// export const ModalBody = withFocusFirstInput(ModalB, "modal-body"); //ModalB;

export const ModalFooter = (props: Object) => (
  <div {...props} className={`modal-footer  ${props.className}`}>
    {props.children}
  </div>
);
